import { CSSProperties, useState, useEffect } from 'react'
import {
    ThinkingState,
} from 'Hooks/useMaestroChat'
import Colors from 'modules/Colors'
import Sty from 'modules/Sty'
import Icon from 'elements/Icon'

const ThinkingSection = ({
    thinkingState,
    initiallyOpen = false
}: {
    thinkingState: ThinkingState,
    initiallyOpen?: boolean
}) => {
    const [isOpen, setIsOpen] = useState(initiallyOpen)

    useEffect(() => {
        setIsOpen(initiallyOpen)
    }, [initiallyOpen])

    // Only show if there's thinking content or actively thinking
    if (!thinkingState.isThinking && !thinkingState.currentThinking) {
        return null
    }

    const sty: Record<string, CSSProperties> = {
        thinkingContainer: {
            marginBottom: 8,
            backgroundColor: '#f8fafc',
            borderRadius: 8,
            padding: '8px 12px',
            border: `1px solid #e2e8f0`,
        },
        thinkingHeader: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'pointer',
            fontWeight: 500,
            color: '#64748b',
        },
        headerText: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
        },
        thinkingContent: {
            paddingTop: 8,
            fontSize: 13,
            lineHeight: 1.5,
            color: '#475569',
            fontStyle: 'italic',
            whiteSpace: 'pre-wrap',
            position: 'relative',
        },
        thinkingCursor: {
            animation: 'typingAnimation 1s infinite',
            color: '#64748b',
            fontSize: 14,
            marginLeft: 2,
        },
    }

    return (
        <div className="thinkingContainer" style={sty.thinkingContainer}>
            <div
                className="thinkingHeader"
                style={sty.thinkingHeader}
                onClick={() => setIsOpen(!isOpen)}
            >
                <div style={sty.headerText}>
                    <Icon
                        icon="gem"
                        size={16}
                        className="thinkingIcon"
                    />
                    <span>
                        {thinkingState.isThinking ? 'Maestro is thinking...' : 'Maestro\'s reasoning'}
                    </span>
                </div>
                <Icon
                    icon={isOpen ? 'chevronUp' : 'chevronDown'}
                    size={16}
                    className="thinkingToggleIcon"
                />
            </div>
            {isOpen && (
                <div className="thinkingContent" style={sty.thinkingContent}>
                    {thinkingState.currentThinking}
                    {thinkingState.isThinking && (
                        <span className="thinkingCursor" style={sty.thinkingCursor}>|</span>
                    )}
                </div>
            )}
        </div>
    )
}

export default ThinkingSection